<image-cropper [imageChangedEvent]="imageChangedEvent" maintainAspectRatio="true" [aspectRatio]="1 / 1"
    format="png" (imageCropped)="imageCropped($event)" [resizeToWidth]="resizeToWidth"
    [cropperMinWidth]="cropperMinWidth" [roundCropper]="true" [cropperMinHeight]="cropperMinHeight" hideResizeSquares="false"
    alignImage="left">
</image-cropper>

<div class="uploader">
    <input type="file" #file id="file" (change)="fileChangeEvent($event)" [disabled]="disableFile" accept="image/png, image/jpeg, image/jpg" />
    <label for="file">Choose a file</label>
    <button pButton [label]="'label_upload' | translate" type="button" class="btn-upload" (click)="onUploadClick()"
        [disabled]="isUploadDisabled"></button>
</div>